import styled from '@mui/material/styles/styled';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';

export const Root = styled('div')(() => ({
  flexGrow: 1,
  height: '100%',
  overflow: 'auto',
  padding: '64px 0 32px'
}));

export const Title = styled(Typography)(() => ({
  fontSize: '1.25rem',
  lineHeight: 1.2,
  fontWeight: 800,
  marginBottom: 24,
}));

export const Fields = styled('div')(({ theme}) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'baseline',
  gap: '16px',
  marginBottom: '24px',
  [theme.breakpoints.up('md')]: {
    flexWrap: 'nowrap',
  }
}));

export const StyledField = styled(TextField)(({ theme }) => ({
  flex: '0 0 100%',
  [theme.breakpoints.up('md')]: {
    flex: '0 0 calc(50% - 8px)'
  }
}));
